import EmailIcon from '@mui/icons-material/Email';
import { useTranslation } from 'react-i18next';

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Typography from '@mui/material/Typography';

type ContactSupportDialogProps = {
  isDialogOpen: boolean;
  onDialogClose: () => void;
};

export const ContactSupportDialog = ({
  isDialogOpen,
  onDialogClose
}: ContactSupportDialogProps) => {
  const { t } = useTranslation('contactSupport');
  const handleCloseDialog = () => onDialogClose();

  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      open={isDialogOpen}
      onClose={handleCloseDialog}
      disableScrollLock
    >
      <DialogTitle className="flex items-center justify-between">
        <Typography variant="bodyMDBold" className="text-text-80">
          {t('header')}
        </Typography>
        <IconButton onClick={handleCloseDialog} aria-label={t('close')}>
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="py-[24px] px-[32px]">
        <Typography component="div" className="text-lkh-text-info mb-[24px]">
          {t('description1')}
        </Typography>

        <div className="flex flex-wrap justify-center items-center gap-[32px] py-[24px] px-[32px] mt-[32px] bg-surface-60 rounded">
          <div
            tabIndex={0}
            role="button"
            aria-label={`${t('contact.location.title')}: ${t('contact.location.detail1')} ${t(
              'contact.location.detail2'
            )}`}
            className="focus:outline-none focus:ring-2 focus:ring-primary-60 focus:ring-offset-2 rounded p-[8px] -m-[8px]"
          >
            <div className="flex">
              <FmdGoodIcon aria-hidden="true" />
              <div className="ml-[8px]">
                <Typography component={'div'} variant="bodySMBold" className="text-text-80">
                  {t('contact.location.title')}
                </Typography>
                <Typography
                  component={'div'}
                  variant="bodySMRegular"
                  className="text-text-60 mt-[8px]"
                >
                  <p className="m-[0px]">{t('contact.location.detail1')}</p>
                  <p className="m-[0px]">{t('contact.location.detail2')}</p>
                </Typography>
              </div>
            </div>
          </div>
          <div
            tabIndex={0}
            role="button"
            aria-label={`${t('contact.number.title')}: ${t('contact.number.detail')}`}
            className="focus:outline-none focus:ring-2 focus:ring-primary-60 focus:ring-offset-2 rounded p-[8px] -m-[8px]"
          >
            <div className="flex">
              <LocalPhoneIcon aria-hidden="true" />
              <div className="ml-[8px]">
                <Typography component={'div'} variant="bodySMBold" className="text-text-80 ">
                  {t('contact.number.title')}
                </Typography>
                <Typography
                  component={'div'}
                  variant="bodySMRegular"
                  className="text-text-60 mt-[8px]"
                >
                  {t('contact.number.detail')}
                </Typography>
              </div>
            </div>
          </div>
          <div
            tabIndex={0}
            role="button"
            aria-label={`${t('contact.email.title')}: ${t('contact.email.title')}`}
            className="focus:outline-none focus:ring-2 focus:ring-primary-60 focus:ring-offset-2 rounded p-[8px] -m-[8px]"
          >
            <div className="flex">
              <EmailIcon aria-hidden="true" />
              <div className="ml-[8px]">
                <Typography
                  component={'a'}
                  variant="bodySMBoldLink"
                  className="text-text-80"
                  href={`mailto:${t('contact.email.title')}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  {t('contact.email.title')}
                </Typography>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[32px]">
          <Typography variant="bodyMDBold" className="text-text-80">
            Benötigen Sie eine Anleitung zur barrierefreien Nutzung? Klicken Sie&nbsp;
          </Typography>
          <Typography
            component="a"
            variant="bodyMDBold"
            rel="noopener noreferrer"
            aria-description="Benötigen Sie eine Anleitung zur barrierefreien Nutzung? Klicken Sie hier"
            href="https://lkh.de/anleitung"
            target="_blank"
            className="text-primary-60 hover:text-primary-80 underline"
            onClick={(e) => e.stopPropagation()}
          >
            hier
          </Typography>
        </div>
      </DialogContent>
    </Dialog>
  );
};
